import styled from 'styled-components';

export const StyledTotalsDiv = styled.div`
    background: var(--brand-4);
    padding-block: 22px;
    padding-inline: 10px;
    border-radius: 6px;
    font-size: 20px;
    font-weight: 700;
`;

export const StyledInvoicesTableWrapper = styled.div`
    & .ant-table {
        font-size: 14px;
        border: none;
        padding-block: 10px;
    }

    & .ant-table-thead > tr > th {
        font-weight: 600;
        background: transparent;
        border-bottom: none !important;
        padding-bottom: 12px !important;
    }

    & .ant-table-thead > tr > th::before {
        background-color: transparent !important;
    }

    & .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
    }

    & .ant-table-tbody > tr:hover > td {
        background: transparent !important;
    }

    & .ant-table-cell {
        border-right: none !important;
    }

    & .ant-table-container {
        border: none;
    }

    & .ant-table-thead > tr > th:first-child,
    & .ant-table-tbody > tr > td:first-child {
        padding-left: 0;
    }

    & .ant-table-thead > tr > th:last-child,
    & .ant-table-tbody > tr > td:last-child {
        padding-right: 0;
    }

    & table {
        border-collapse: separate;
        border-spacing: 0;
    }

    & .ant-table-tbody > tr.row-disabled > td {
        opacity: 0.4;
        pointer-events: none;
        user-select: none;
    }

    & .ant-table-tbody > tr.row-disabled > td:last-child {
        pointer-events: auto;
    }
`;
